import { computed as e, defineComponent as t, ref as n, watch as r } from "vue";
//#region src/types.ts
var i = /* @__PURE__ */ function(e) {
	return e.Any = "any", e.Value = "value", e.Range = "range", e.Step = "step", e.StepFrom = "stepFrom", e.RangeStep = "rangeStep", e.Combined = "combined", e.NoSpecific = "noSpecific", e;
}({}), a = /* @__PURE__ */ function(e) {
	return e.Prefix = "prefix", e.Suffix = "suffix", e.Text = "text", e;
}({}), o = class {
	field;
	itemMap;
	ctx;
	constructor(e, t) {
		this.field = e, this.ctx = t, this.itemMap = this.field.items.reduce((e, t) => (e[t.value] = t, e), {});
	}
	get id() {
		return this.field.id;
	}
	get items() {
		return this.field.items;
	}
	get onChange() {
		return this.field.onChange;
	}
	get segmentFactories() {
		return this.field.segmentFactories;
	}
	get min() {
		return this.items[0].value;
	}
	get max() {
		return this.items[this.items.length - 1].value;
	}
	getItem(e) {
		return this.itemMap[e];
	}
};
//#endregion
//#region src/util.ts
function s(e, t, n = 1) {
	let r = [];
	for (let i = e; i <= t; i += n) r.push(i);
	return r;
}
var c = class {
	start;
	end;
	step;
	constructor(e, t, n = 1) {
		return this.start = e, this.end = t, this.step = n, new Proxy(this, { get: function(e, t) {
			let n = typeof t == "string" ? parseInt(t) : t;
			return typeof n == "number" && n >= 0 && n <= e.length ? e.start + e.step * n : Reflect.get(e, t);
		} });
	}
	get length() {
		return (this.end - this.start) / this.step + 1;
	}
	[Symbol.iterator]() {
		let e = -1;
		return { next: () => ({
			value: this[++e],
			done: this[e + 1] === void 0
		}) };
	}
};
function l(e, t, n = (e) => e + "", r = (e) => e + "") {
	let i = [];
	for (let a of new c(e, t)) i.push({
		text: n(a),
		alt: r(a),
		value: a
	});
	return i;
}
function u(e, t = "crontab") {
	let n = (t, n = !1) => new Date(2021, t - 1, 1).toLocaleDateString(e, { month: n ? "short" : "long" }), r = (t, n = !1) => new Date(2021, 0, 3 + t).toLocaleDateString(e, { weekday: n ? "short" : "long" });
	return {
		secondItems: l(0, 59, (e) => d(e, 2)),
		minuteItems: l(0, 59, (e) => d(e, 2)),
		hourItems: l(0, 23, (e) => d(e, 2)),
		dayItems: l(1, 31),
		monthItems: l(1, 12, n, (e) => n(e, !0)),
		dayOfWeekItems: t === "quartz" ? l(1, 7, (e) => r(e - 1), (e) => r(e - 1, !0)) : l(0, 6, r, (e) => r(e, !0))
	};
}
function d(e, t) {
	let n = e + "";
	return n.length < t ? Array(t - n.length).fill("0").join("") + e : n;
}
function f(e) {
	return e && typeof e == "object" && !Array.isArray(e);
}
function p(e, ...t) {
	if (!f(e) || t.length === 0) return;
	let n = t.shift();
	if (f(n)) for (let [t, r] of Object.entries(n)) f(r) ? (f(e[t]) || (e[t] = {}), p(e[t], n[t])) : e[t] = n[t];
	return t.length > 0 && p(e, ...t), e;
}
function m(e, ...t) {
	if (t.length === 0) return e;
	for (let n of t[0]) if (n in e) {
		let r = m(e[n], ...t.slice(1));
		if (r !== void 0) return r;
	}
}
function h(e) {
	for (let t = 1; t < e.length; t++) if (e[t - 1] + 1 !== e[t]) return !1;
	return !0;
}
function g() {
	throw Error("not implemented");
}
function _(e, t, n = !0) {
	let r = [];
	for (let i = 0; i < e.length; i += t) {
		let a = e.slice(i, i + t);
		for (; n && a.length < t;) a.push(null);
		r.push(a);
	}
	return r;
}
//#endregion
//#region src/cron.ts
var v = class e {
	field;
	type = i.NoSpecific;
	constructor(e) {
		this.field = e;
	}
	toCron() {
		return "?";
	}
	toArray() {
		return [];
	}
	get items() {
		return {};
	}
	static fromString(t, n) {
		return t === "?" ? new e(n) : null;
	}
}, y = class e {
	field;
	type = i.Any;
	constructor(e) {
		this.field = e;
	}
	toCron() {
		return "*";
	}
	toArray() {
		return [];
	}
	get items() {
		return {};
	}
	static fromString(t, n) {
		return t === "*" ? new e(n) : null;
	}
	static fromArray(t, n) {
		let { items: r } = n;
		if (t.length === 0) return new e(n);
		if (t.length !== r.length) return null;
		for (let e of r) if (!t.includes(e.value)) return null;
		return h(r.map((e) => e.value)) ? new e(n) : null;
	}
}, b = class e {
	static re = /^\d+-\d+$/;
	field;
	type = i.Range;
	start;
	end;
	constructor(e, t, n) {
		this.field = e, this.start = t, this.end = n;
	}
	toCron() {
		return `${this.start}-${this.end}`;
	}
	toArray() {
		let e = this.start, t = this.end;
		return s(e, t);
	}
	get items() {
		return {
			start: this.field.itemMap[this.start],
			end: this.field.itemMap[this.end]
		};
	}
	static fromString(t, n) {
		if (!e.re.test(t)) return null;
		let { min: r, max: i } = n, a = t.split("-"), o = parseInt(a[0]), s = parseInt(a[1]);
		return o > s || o < r || s > i ? null : new e(n, o, s);
	}
};
function x(e, t, n) {
	let r = [];
	for (let i = t; i <= n; i += e) r.push(i);
	return r;
}
function S(e, t) {
	if (e === "*") return [t.min, t.max];
	let n = e.split("-").map((e) => parseInt(e));
	return n.length === 1 && t.ctx.format !== "crontab" ? [n[0], t.max] : [n[0], n[1]];
}
var C = class e {
	static re = /^(\*|\d+(-\d+)?)\/\d+$/;
	field;
	step;
	start;
	end;
	constructor(e, t, n, r) {
		this.field = e, this.step = t, this.start = n ?? e.min, this.end = r ?? e.max;
	}
	get type() {
		let { min: e, max: t } = this.field;
		return this.field.ctx.format !== "crontab" && this.start !== e && t - this.end < this.step ? i.StepFrom : this.start !== e || t - this.end >= this.step ? i.RangeStep : i.Step;
	}
	toCron() {
		return this.type === i.StepFrom ? `${this.start}/${this.step}` : this.type === i.RangeStep ? `${this.start}-${this.end}/${this.step}` : `*/${this.step}`;
	}
	toArray() {
		return x(this.step, this.start, this.end);
	}
	get items() {
		return {
			step: this.field.itemMap[this.step],
			start: this.field.itemMap[this.start],
			end: this.field.itemMap[this.end]
		};
	}
	static fromString(t, n) {
		if (!e.re.test(t)) return null;
		let [r, i] = t.split("/"), a = parseInt(i);
		if (a > n.items.length) return null;
		let [o, s] = S(r, n);
		return x(a, o, s).length == 0 ? null : new e(n, a, o, s);
	}
	static fromArray(t, n) {
		if (t.length < 3) return null;
		let r = t[1] - t[0];
		if (r <= 1) return null;
		for (let e = 2; e < t.length; e++) if (t[e] - t[e - 1] != r) return null;
		return new e(n, r, t[0], t[t.length - 1]);
	}
}, w = class e {
	field;
	type = i.Value;
	value;
	constructor(e, t) {
		this.field = e, this.value = t;
	}
	toCron() {
		return `${this.value}`;
	}
	toArray() {
		return [this.value];
	}
	get items() {
		return { value: this.field.itemMap[this.value] };
	}
	static fromString(t, n) {
		let { min: r, max: i } = n, a = parseInt(t);
		return String(a) === t && a >= r && a <= i ? new e(n, a) : null;
	}
	static fromArray(e, t) {
		let { min: n, max: r } = t;
		if (e.length != 1) return null;
		let i = e[0];
		return i < n || i > r ? null : i;
	}
}, T = class e {
	static segmentFactories = [
		y.fromString,
		C.fromString,
		b.fromString,
		w.fromString
	];
	field;
	segments;
	constructor(e, t = []) {
		this.field = e, this.segments = t;
	}
	get type() {
		return this.segments.length == 1 ? this.segments[0].type : i.Range;
	}
	addSegment(e) {
		this.segments.push(e);
	}
	toCron() {
		return this.segments.map((e) => e.toCron()).join(",");
	}
	toArray() {
		let e = /* @__PURE__ */ new Set();
		for (let t of this.segments) t.toArray().forEach((t) => e.add(t));
		return Array.from(e);
	}
	get items() {
		return g();
	}
	static fromString(t, n) {
		let r = n.segmentFactories ?? e.segmentFactories, i = [];
		for (let e of t.split(",")) {
			if (e === "*") {
				i = [new y(n)];
				break;
			}
			let t = null;
			for (let i of r) if (t = i(e, n), t !== null) break;
			if (t === null) return null;
			i.push(t);
		}
		return new e(n, i);
	}
	static fromArray(t, n) {
		let { min: r, max: i } = n, a = t[0], o = t[t.length - 1];
		if (a < r || o > i) return null;
		let s = [], c = 0;
		for (let e = 0; e < t.length; e++) (t[e + 1] === void 0 || t[e + 1] - t[e] > 1) && (e === c ? s.push(new w(n, t[c])) : s.push(new b(n, t[c], t[e])), c = e + 1);
		return new e(n, s);
	}
};
function E(e, t) {
	return T.fromString(e, t);
}
function D(e, t) {
	for (let n of [
		y.fromArray,
		C.fromArray,
		T.fromArray
	]) {
		let r = n(e, t);
		if (r != null) return r;
	}
	return null;
}
//#endregion
//#region ../node_modules/mustache/mustache.mjs
var O = Object.prototype.toString, k = Array.isArray || function(e) {
	return O.call(e) === "[object Array]";
};
function A(e) {
	return typeof e == "function";
}
function j(e) {
	return k(e) ? "array" : typeof e;
}
function M(e) {
	return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function N(e, t) {
	return typeof e == "object" && !!e && t in e;
}
function ee(e, t) {
	return e != null && typeof e != "object" && e.hasOwnProperty && e.hasOwnProperty(t);
}
var te = RegExp.prototype.test;
function ne(e, t) {
	return te.call(e, t);
}
var P = /\S/;
function F(e) {
	return !ne(P, e);
}
var re = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;",
	"/": "&#x2F;",
	"`": "&#x60;",
	"=": "&#x3D;"
};
function I(e) {
	return String(e).replace(/[&<>"'`=\/]/g, function(e) {
		return re[e];
	});
}
var ie = /\s*/, ae = /\s+/, L = /\s*=/, oe = /\s*\}/, se = /#|\^|\/|>|\{|&|=|!/;
function ce(e, t) {
	if (!e) return [];
	var n = !1, r = [], i = [], a = [], o = !1, s = !1, c = "", l = 0;
	function u() {
		if (o && !s) for (; a.length;) delete i[a.pop()];
		else a = [];
		o = !1, s = !1;
	}
	var d, f, p;
	function m(e) {
		if (typeof e == "string" && (e = e.split(ae, 2)), !k(e) || e.length !== 2) throw Error("Invalid tags: " + e);
		d = RegExp(M(e[0]) + "\\s*"), f = RegExp("\\s*" + M(e[1])), p = RegExp("\\s*" + M("}" + e[1]));
	}
	m(t || V.tags);
	for (var h = new R(e), g, _, v, y, b, x; !h.eos();) {
		if (g = h.pos, v = h.scanUntil(d), v) for (var S = 0, C = v.length; S < C; ++S) y = v.charAt(S), F(y) ? (a.push(i.length), c += y) : (s = !0, n = !0, c += " "), i.push([
			"text",
			y,
			g,
			g + 1
		]), g += 1, y === "\n" && (u(), c = "", l = 0, n = !1);
		if (!h.scan(d)) break;
		if (o = !0, _ = h.scan(se) || "name", h.scan(ie), _ === "=" ? (v = h.scanUntil(L), h.scan(L), h.scanUntil(f)) : _ === "{" ? (v = h.scanUntil(p), h.scan(oe), h.scanUntil(f), _ = "&") : v = h.scanUntil(f), !h.scan(f)) throw Error("Unclosed tag at " + h.pos);
		if (b = _ == ">" ? [
			_,
			v,
			g,
			h.pos,
			c,
			l,
			n
		] : [
			_,
			v,
			g,
			h.pos
		], l++, i.push(b), _ === "#" || _ === "^") r.push(b);
		else if (_ === "/") {
			if (x = r.pop(), !x) throw Error("Unopened section \"" + v + "\" at " + g);
			if (x[1] !== v) throw Error("Unclosed section \"" + x[1] + "\" at " + g);
		} else _ === "name" || _ === "{" || _ === "&" ? s = !0 : _ === "=" && m(v);
	}
	if (u(), x = r.pop(), x) throw Error("Unclosed section \"" + x[1] + "\" at " + h.pos);
	return ue(le(i));
}
function le(e) {
	for (var t = [], n, r, i = 0, a = e.length; i < a; ++i) n = e[i], n && (n[0] === "text" && r && r[0] === "text" ? (r[1] += n[1], r[3] = n[3]) : (t.push(n), r = n));
	return t;
}
function ue(e) {
	for (var t = [], n = t, r = [], i, a, o = 0, s = e.length; o < s; ++o) switch (i = e[o], i[0]) {
		case "#":
		case "^":
			n.push(i), r.push(i), n = i[4] = [];
			break;
		case "/":
			a = r.pop(), a[5] = i[2], n = r.length > 0 ? r[r.length - 1][4] : t;
			break;
		default: n.push(i);
	}
	return t;
}
function R(e) {
	this.string = e, this.tail = e, this.pos = 0;
}
R.prototype.eos = function() {
	return this.tail === "";
}, R.prototype.scan = function(e) {
	var t = this.tail.match(e);
	if (!t || t.index !== 0) return "";
	var n = t[0];
	return this.tail = this.tail.substring(n.length), this.pos += n.length, n;
}, R.prototype.scanUntil = function(e) {
	var t = this.tail.search(e), n;
	switch (t) {
		case -1:
			n = this.tail, this.tail = "";
			break;
		case 0:
			n = "";
			break;
		default: n = this.tail.substring(0, t), this.tail = this.tail.substring(t);
	}
	return this.pos += n.length, n;
};
function z(e, t) {
	this.view = e, this.cache = { ".": this.view }, this.parent = t;
}
z.prototype.push = function(e) {
	return new z(e, this);
}, z.prototype.lookup = function(e) {
	var t = this.cache, n;
	if (t.hasOwnProperty(e)) n = t[e];
	else {
		for (var r = this, i, a, o, s = !1; r;) {
			if (e.indexOf(".") > 0) for (i = r.view, a = e.split("."), o = 0; i != null && o < a.length;) o === a.length - 1 && (s = N(i, a[o]) || ee(i, a[o])), i = i[a[o++]];
			else i = r.view[e], s = N(r.view, e);
			if (s) {
				n = i;
				break;
			}
			r = r.parent;
		}
		t[e] = n;
	}
	return A(n) && (n = n.call(this.view)), n;
};
function B() {
	this.templateCache = {
		_cache: {},
		set: function(e, t) {
			this._cache[e] = t;
		},
		get: function(e) {
			return this._cache[e];
		},
		clear: function() {
			this._cache = {};
		}
	};
}
B.prototype.clearCache = function() {
	this.templateCache !== void 0 && this.templateCache.clear();
}, B.prototype.parse = function(e, t) {
	var n = this.templateCache, r = e + ":" + (t || V.tags).join(":"), i = n !== void 0, a = i ? n.get(r) : void 0;
	return a ?? (a = ce(e, t), i && n.set(r, a)), a;
}, B.prototype.render = function(e, t, n, r) {
	var i = this.getConfigTags(r), a = this.parse(e, i), o = t instanceof z ? t : new z(t, void 0);
	return this.renderTokens(a, o, n, e, r);
}, B.prototype.renderTokens = function(e, t, n, r, i) {
	for (var a = "", o, s, c, l = 0, u = e.length; l < u; ++l) c = void 0, o = e[l], s = o[0], s === "#" ? c = this.renderSection(o, t, n, r, i) : s === "^" ? c = this.renderInverted(o, t, n, r, i) : s === ">" ? c = this.renderPartial(o, t, n, i) : s === "&" ? c = this.unescapedValue(o, t) : s === "name" ? c = this.escapedValue(o, t, i) : s === "text" && (c = this.rawValue(o)), c !== void 0 && (a += c);
	return a;
}, B.prototype.renderSection = function(e, t, n, r, i) {
	var a = this, o = "", s = t.lookup(e[1]);
	function c(e) {
		return a.render(e, t, n, i);
	}
	if (s) {
		if (k(s)) for (var l = 0, u = s.length; l < u; ++l) o += this.renderTokens(e[4], t.push(s[l]), n, r, i);
		else if (typeof s == "object" || typeof s == "string" || typeof s == "number") o += this.renderTokens(e[4], t.push(s), n, r, i);
		else if (A(s)) {
			if (typeof r != "string") throw Error("Cannot use higher-order sections without the original template");
			s = s.call(t.view, r.slice(e[3], e[5]), c), s != null && (o += s);
		} else o += this.renderTokens(e[4], t, n, r, i);
		return o;
	}
}, B.prototype.renderInverted = function(e, t, n, r, i) {
	var a = t.lookup(e[1]);
	if (!a || k(a) && a.length === 0) return this.renderTokens(e[4], t, n, r, i);
}, B.prototype.indentPartial = function(e, t, n) {
	for (var r = t.replace(/[^ \t]/g, ""), i = e.split("\n"), a = 0; a < i.length; a++) i[a].length && (a > 0 || !n) && (i[a] = r + i[a]);
	return i.join("\n");
}, B.prototype.renderPartial = function(e, t, n, r) {
	if (n) {
		var i = this.getConfigTags(r), a = A(n) ? n(e[1]) : n[e[1]];
		if (a != null) {
			var o = e[6], s = e[5], c = e[4], l = a;
			s == 0 && c && (l = this.indentPartial(a, c, o));
			var u = this.parse(l, i);
			return this.renderTokens(u, t, n, l, r);
		}
	}
}, B.prototype.unescapedValue = function(e, t) {
	var n = t.lookup(e[1]);
	if (n != null) return n;
}, B.prototype.escapedValue = function(e, t, n) {
	var r = this.getConfigEscape(n) || V.escape, i = t.lookup(e[1]);
	if (i != null) return typeof i == "number" && r === V.escape ? String(i) : r(i);
}, B.prototype.rawValue = function(e) {
	return e[1];
}, B.prototype.getConfigTags = function(e) {
	if (k(e)) return e;
	if (e && typeof e == "object") return e.tags;
}, B.prototype.getConfigEscape = function(e) {
	if (e && typeof e == "object" && !k(e)) return e.escape;
};
var V = {
	name: "mustache.js",
	version: "4.2.0",
	tags: ["{{", "}}"],
	clearCache: void 0,
	escape: void 0,
	parse: void 0,
	render: void 0,
	Scanner: void 0,
	Context: void 0,
	Writer: void 0,
	set templateCache(e) {
		H.templateCache = e;
	},
	get templateCache() {
		return H.templateCache;
	}
}, H = new B();
V.clearCache = function() {
	return H.clearCache();
}, V.parse = function(e, t) {
	return H.parse(e, t);
}, V.render = function(e, t, n, r) {
	if (typeof e != "string") throw TypeError("Invalid template! Template should be a \"string\" but \"" + j(e) + "\" was given as the first argument for mustache#render(template, view, partials)");
	return H.render(e, t, n, r);
}, V.escape = I, V.Scanner = R, V.Context = z, V.Writer = B;
//#endregion
//#region src/locale/index.ts
var U = {
	empty: {},
	en: {
		"*": {
			prefix: "Every",
			suffix: "",
			text: "Unknown",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "every {{step.value}}" },
				rangeStep: { text: "{{start.text}}-{{end.text}}/{{step.value}}" },
				stepFrom: { text: "{{start.text}}/{{step.value}}" }
			},
			month: {
				"*": { prefix: "in" },
				any: { text: "every month" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				rangeStep: { text: "{{start.alt}}-{{end.alt}}/{{step.value}}" },
				stepFrom: { text: "{{start.alt}}/{{step.value}}" }
			},
			day: {
				"*": { prefix: "on" },
				any: { text: "every day" },
				noSpecific: { text: "no specific day" }
			},
			dayOfWeek: {
				"*": { prefix: "on" },
				any: { text: "every day of the week" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				rangeStep: { text: "{{start.alt}}-{{end.alt}}/{{step.value}}" },
				stepFrom: { text: "{{start.alt}}/{{step.value}}" },
				noSpecific: { text: "no specific day of the week" }
			},
			hour: {
				"*": { prefix: "at" },
				any: { text: "every hour" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "every minute" }
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "every second" }
			}
		},
		minute: { text: "Minute" },
		hour: {
			text: "Hour",
			minute: {
				"*": {
					prefix: "at",
					suffix: "minute(s)"
				},
				any: { text: "every" }
			}
		},
		day: { text: "Day" },
		week: { text: "Week" },
		month: {
			text: "Month",
			dayOfWeek: { "*": { prefix: "and" } }
		},
		year: {
			text: "Year",
			dayOfWeek: { "*": { prefix: "and" } }
		},
		"q-second": { text: "Second" },
		"q-minute": {
			text: "Minute",
			second: {
				"*": {
					prefix: "at",
					suffix: "second(s)"
				},
				any: { text: "every" }
			}
		},
		"q-hour": {
			text: "Hour",
			minute: { "*": { prefix: "at" } }
		}
	},
	de: {
		"*": {
			prefix: "Jede",
			suffix: "",
			text: "Unknown",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "alle {{step.value}}" }
			},
			month: {
				"*": { prefix: "im" },
				any: {
					prefix: "in",
					text: "jedem Monat"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "den" },
				any: {
					prefix: "an",
					text: "jedem Tag"
				},
				step: {
					prefix: "",
					text: "alle {{step.value}} Tage"
				},
				noSpecific: {
					prefix: "an",
					text: "keinem bestimmten Tag"
				}
			},
			dayOfWeek: {
				"*": { prefix: "am" },
				any: {
					prefix: "an",
					text: "jedem Wochentag"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "und",
					text: "keinem bestimmten Wochentag"
				}
			},
			hour: {
				"*": { prefix: "um" },
				any: {
					prefix: "zu",
					text: "jeder Stunde"
				},
				step: {
					prefix: "",
					text: "alle {{step.value}} Stunden"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "jede Minute" },
				step: {
					prefix: "",
					text: "alle {{step.value}} Minuten"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "jede Sekunde" },
				step: {
					prefix: "",
					text: "alle {{step.value}} Sekunden"
				}
			}
		},
		minute: { text: "Minute" },
		hour: {
			text: "Stunde",
			minute: {
				"*": {
					prefix: "zu",
					suffix: "Minute(n)"
				},
				any: { text: "jeder" }
			}
		},
		day: {
			prefix: "Jeden",
			text: "Tag"
		},
		week: { text: "Woche" },
		month: {
			prefix: "Jedes",
			text: "Monat"
		},
		year: {
			prefix: "Jedes",
			text: "Jahr"
		},
		"q-second": { text: "Sekunde" },
		"q-minute": {
			text: "Minute",
			second: { "*": { prefix: "und" } }
		},
		"q-hour": {
			text: "Stunde",
			minute: { "*": { prefix: "und" } },
			second: { "*": { prefix: "und" } }
		}
	},
	pt: {
		"*": {
			prefix: "Todo(a)",
			suffix: "",
			text: "Desconhecido",
			"*": {
				any: { text: "todo {{field.id}}" },
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "todo {{step.value}}" }
			},
			month: {
				"*": { prefix: "de" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				any: { text: "todo mês" }
			},
			day: {
				"*": { prefix: "no(s) dia(s)" },
				any: { text: "todos" }
			},
			dayOfWeek: {
				"*": { prefix: "de" },
				any: { text: "todos dias da semana" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			hour: {
				"*": { prefix: "às" },
				any: { text: "cada hora" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "cada minuto" }
			}
		},
		minute: { text: "Minuto" },
		hour: {
			text: "Hora",
			minute: {
				"*": {
					prefix: "e",
					suffix: "minuto(s)"
				},
				any: { text: "cada" }
			}
		},
		day: { text: "Dia" },
		week: { text: "Semana" },
		month: {
			text: "Mês",
			dayOfWeek: { "*": { prefix: "e de" } }
		},
		year: {
			text: "Ano",
			dayOfWeek: { "*": { prefix: "e de" } }
		}
	},
	es: {
		"*": {
			prefix: "todos los",
			suffix: "",
			text: "Desconocido",
			"*": {
				any: { text: "todos los {{ field.id }}" },
				value: { text: "{{ value.text }}" },
				range: { text: "{{ start.text }}-{{ end.text }}" },
				step: { text: "todos/as {{ step.value }}" }
			},
			month: {
				"*": { prefix: "en" },
				any: { text: "todos los meses" },
				value: { text: "{{ value.alt }}" },
				range: { text: "{{ start.alt }}-{{ end.alt }}" }
			},
			day: {
				"*": { prefix: "en" },
				any: { text: "todos los días" },
				value: { text: "los días {{ value.alt }}" }
			},
			dayOfWeek: {
				"*": { prefix: "de" },
				any: { text: "todos los días de la semana" },
				value: { text: "los {{ value.alt }}" },
				range: { text: "{{ start.alt }}-{{ end.alt }}" }
			},
			hour: {
				"*": { prefix: "a" },
				any: { text: "todas las horas" },
				value: { text: "las {{ value.text }}" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "todos los minutos" }
			}
		},
		minute: {
			prefix: "todos los",
			text: "minutos"
		},
		hour: {
			prefix: "todas las",
			text: "horas",
			minute: {
				"*": {
					prefix: "a los",
					suffix: "minutos"
				},
				any: {
					text: "todos",
					prefix: "a",
					suffix: "los minutos"
				}
			}
		},
		day: { text: "Días" },
		week: { text: "Semanas" },
		month: {
			text: "Meses",
			dayOfWeek: { "*": { prefix: "y" } }
		},
		year: {
			text: "años",
			dayOfWeek: { "*": { prefix: "y" } }
		}
	},
	da: {
		"*": {
			prefix: "Hver",
			suffix: "",
			text: "Ukendt",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "hver {{step.value}}" }
			},
			month: {
				"*": { prefix: "i" },
				any: { text: "hver måned" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "og" },
				any: { text: "hver dag i måneden" },
				value: { text: "{{value.alt}}." },
				range: { text: "{{start.alt}}.-{{end.alt}}." },
				noSpecific: { text: "ingen specifik dag" }
			},
			dayOfWeek: {
				"*": { prefix: "på" },
				any: { text: "hver dag i ugen" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: { text: "ingen specifik dag i ugen" }
			},
			hour: {
				"*": { prefix: "klokken" },
				any: { text: "hver time" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "hvert minut" }
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "hvert sekund" }
			}
		},
		second: { prefix: "Hvert" },
		minute: {
			prefix: "Hvert",
			text: "Minut"
		},
		hour: {
			text: "Time",
			minute: {
				"*": {
					prefix: "ved",
					suffix: "minutter"
				},
				any: { text: "alle" }
			}
		},
		day: { text: "Dag" },
		week: { text: "Uge" },
		month: {
			text: "Måned",
			dayOfWeek: { "*": { prefix: "og" } }
		},
		year: {
			prefix: "Hvert",
			text: "År",
			dayOfWeek: { "*": { prefix: "og" } }
		},
		"q-second": { text: "Sekund" },
		"q-minute": {
			text: "Minut",
			second: {
				"*": { suffix: "sekund(er)" },
				any: { text: "hvert" }
			}
		},
		"q-hour": {
			text: "Time",
			minute: { "*": { prefix: "på" } }
		}
	},
	zh: {
		"*": {
			prefix: "每",
			suffix: "",
			text: "未知",
			"*": {
				any: { text: "每 {{field.id}}" },
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "每 {{step.value}}" }
			},
			month: {
				"*": { prefix: "的" },
				any: { text: "每月" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "的" },
				any: { text: "每日" },
				value: { text: "{{value.alt}}号" },
				range: { text: "{{start.alt}}号-{{end.alt}}号" },
				noSpecific: { text: "无特定日期" }
			},
			dayOfWeek: {
				"*": { prefix: "的" },
				any: { text: "一周的每一天" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: { text: "无特定星期几" }
			},
			hour: {
				"*": { prefix: "的" },
				any: { text: "每小时" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "每分钟" }
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "每秒" }
			}
		},
		minute: { text: "分" },
		hour: {
			text: "小时",
			minute: {
				"*": {
					prefix: ":",
					suffix: "分钟"
				},
				any: { text: "每" }
			}
		},
		day: { text: "天" },
		week: {
			text: "周",
			dayOfWeek: {
				"*": { prefix: "的" },
				any: { text: "每天" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			}
		},
		month: {
			text: "月",
			dayOfWeek: { "*": { prefix: "和" } },
			day: { "*": { prefix: "的" } }
		},
		year: {
			text: "年",
			dayOfWeek: { "*": { prefix: "和" } }
		},
		"q-second": { text: "秒" },
		"q-minute": {
			text: "分钟",
			second: {
				"*": {
					prefix: ":",
					suffix: "秒"
				},
				any: { text: "每" }
			}
		},
		"q-hour": {
			text: "小时",
			minute: { "*": { prefix: ":" } }
		}
	},
	he: {
		"*": {
			prefix: "בכל",
			suffix: "",
			text: "לא ידוע",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "כל {{step.value}}" }
			},
			month: {
				"*": { prefix: "ב" },
				any: { text: "כל חודש" },
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "ב" },
				any: { text: "כל יום" },
				value: { text: "יום {{value.alt}} לחודש" },
				noSpecific: { text: "ללא יום מוגדר" }
			},
			dayOfWeek: {
				"*": { prefix: "ב" },
				any: { text: "כל יום מימות השבוע" },
				value: { text: "ימי {{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: { text: "ללא יום בשבוע מוגדר" }
			},
			hour: {
				"*": { prefix: "ב" },
				any: { text: "כל שעה" },
				value: { text: "שעה {{value.text}}" }
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "כל דקה" }
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "כל שניה" }
			}
		},
		minute: { text: "דקה" },
		hour: {
			text: "שעה",
			minute: {
				"*": {
					prefix: "ב",
					suffix: "דקות"
				},
				any: { text: "כל" }
			}
		},
		day: { text: "יום" },
		week: { text: "שבוע" },
		month: {
			text: "חודש",
			dayOfWeek: { "*": { prefix: "ו" } }
		},
		year: {
			text: "שנה",
			dayOfWeek: { "*": { prefix: "ו" } }
		},
		"q-second": { text: "שניה" },
		"q-minute": {
			text: "דקה",
			second: {
				"*": {
					prefix: "ב",
					suffix: "שניות"
				},
				any: { text: "כל" }
			}
		},
		"q-hour": {
			text: "שעה",
			minute: { "*": { prefix: "ב" } }
		}
	},
	ru: {
		"*": {
			prefix: "Каждый",
			suffix: "",
			text: "Неизвестно",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "каждый {{step.value}}" }
			},
			month: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "каждом месяце"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "каждый день"
				},
				step: {
					prefix: "",
					text: "каждые {{step.value}} дня"
				},
				noSpecific: {
					prefix: "в",
					text: "нет определенного дня"
				}
			},
			dayOfWeek: {
				"*": { prefix: "по" },
				any: {
					prefix: "по",
					text: "каждому дню недели"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "и",
					text: "нет определенного дня недели"
				}
			},
			hour: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "каждый час"
				},
				step: {
					prefix: "",
					text: "каждые {{step.value}} часа"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "каждую минуту" },
				step: {
					prefix: "",
					text: "каждые {{step.value}} минуты"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "каждую секунду" },
				step: {
					prefix: "",
					text: "каждые {{step.value}} секунды"
				}
			}
		},
		minute: { text: "Минута" },
		hour: {
			text: "Час",
			minute: {
				"*": {
					prefix: "в",
					suffix: "минут(а/ы)"
				},
				any: { text: "каждый" }
			}
		},
		day: {
			prefix: "Каждый",
			text: "День"
		},
		week: { text: "Неделя" },
		month: {
			prefix: "Каждый",
			text: "Месяц"
		},
		year: {
			prefix: "Каждый",
			text: "Год"
		},
		"q-second": { text: "Секунда" },
		"q-minute": {
			text: "Минута",
			second: { "*": { prefix: "и" } }
		},
		"q-hour": {
			text: "Час",
			minute: { "*": { prefix: "и" } },
			second: { "*": { prefix: "и" } }
		}
	},
	fr: {
		"*": {
			prefix: "Toutes",
			suffix: "",
			text: "Inconnu",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "tous les {{step.value}}" }
			},
			month: {
				"*": { prefix: "en" },
				any: {
					prefix: "en",
					text: "tous les mois"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "le" },
				any: {
					prefix: "à",
					text: "tous les jours"
				},
				step: {
					prefix: "",
					text: "tous les {{step.value}} jours"
				},
				noSpecific: {
					prefix: "à",
					text: "aucun jour particulier"
				}
			},
			dayOfWeek: {
				"*": { prefix: "le" },
				any: {
					prefix: "à",
					text: "tous les jours de la semaine"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "et",
					text: "aucun jour de la semaine particulier"
				}
			},
			hour: {
				"*": { prefix: "à" },
				any: {
					prefix: "à",
					text: "toutes les heures"
				},
				step: {
					prefix: "",
					text: "toutes les {{step.value}} heures"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "toutes les minutes" },
				step: {
					prefix: "",
					text: "toutes les {{step.value}} minutes"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "toutes les secondes" },
				step: {
					prefix: "",
					text: "toutes les {{step.value}} secondes"
				}
			}
		},
		minute: { text: "Minute" },
		hour: {
			text: "Heure",
			minute: {
				"*": {
					prefix: "à",
					suffix: "minute(s)"
				},
				any: { text: "toutes" }
			}
		},
		day: {
			prefix: "Tous",
			text: "Jour"
		},
		week: { text: "Semaine" },
		month: {
			prefix: "Tous",
			text: "Mois"
		},
		year: {
			prefix: "Tous",
			text: "Année"
		},
		"q-second": { text: "Seconde" },
		"q-minute": {
			text: "Minute",
			second: { "*": { prefix: "et" } }
		},
		"q-hour": {
			text: "Heure",
			minute: { "*": { prefix: "et" } },
			second: { "*": { prefix: "et" } }
		}
	},
	hi: {
		"*": {
			prefix: "हर",
			suffix: "",
			text: "अज्ञात",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "{{step.value}} हर" }
			},
			month: {
				"*": { prefix: "में" },
				any: {
					prefix: "के",
					text: "हर महीने"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "के" },
				any: {
					prefix: "पर",
					text: "हर दिन"
				},
				step: {
					prefix: "",
					text: "{{step.value}} दिन हर"
				},
				noSpecific: {
					prefix: "पर",
					text: "कोई विशेष दिन नहीं"
				}
			},
			dayOfWeek: {
				"*": { prefix: "पर" },
				any: {
					prefix: "पर",
					text: "हर सप्ताह"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "और",
					text: "कोई विशेष सप्ताह नहीं"
				}
			},
			hour: {
				"*": { prefix: "को" },
				any: {
					prefix: "पर",
					text: "हर घंटे"
				},
				step: {
					prefix: "",
					text: "{{step.value}} घंटे हर"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "हर मिनट" },
				step: {
					prefix: "",
					text: "{{step.value}} मिनट हर"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "हर सेकंड" },
				step: {
					prefix: "",
					text: "{{step.value}} सेकंड हर"
				}
			}
		},
		minute: { text: "मिनट" },
		hour: {
			text: "घंटा",
			minute: {
				"*": {
					prefix: "पर",
					suffix: "मिनट"
				},
				any: { text: "हर" }
			}
		},
		day: {
			prefix: "हर",
			text: "दिन"
		},
		week: { text: "सप्ताह" },
		month: {
			prefix: "हर",
			text: "महीना"
		},
		year: {
			prefix: "हर",
			text: "साल"
		},
		"q-second": { text: "सेकंड" },
		"q-minute": {
			text: "मिनट",
			second: { "*": { prefix: "और" } }
		},
		"q-hour": {
			text: "घंटा",
			minute: { "*": { prefix: "और" } },
			second: { "*": { prefix: "और" } }
		}
	},
	ja: {
		"*": {
			prefix: "毎",
			suffix: "",
			text: "不明",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "{{step.value}}ごとに" }
			},
			month: {
				"*": { prefix: "に" },
				any: {
					prefix: "の",
					text: "毎月"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "の" },
				any: {
					prefix: "に",
					text: "毎日"
				},
				step: {
					prefix: "",
					text: "{{step.value}}日ごとに"
				},
				noSpecific: {
					prefix: "に",
					text: "特定の日はなし"
				}
			},
			dayOfWeek: {
				"*": { prefix: "の" },
				any: {
					prefix: "に",
					text: "毎週"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "と",
					text: "特定の曜日はなし"
				}
			},
			hour: {
				"*": { prefix: "の" },
				any: {
					prefix: "に",
					text: "毎時"
				},
				step: {
					prefix: "",
					text: "{{step.value}}時間ごとに"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "毎分" },
				step: {
					prefix: "",
					text: "{{step.value}}分ごとに"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "毎秒" },
				step: {
					prefix: "",
					text: "{{step.value}}秒ごとに"
				}
			}
		},
		minute: { text: "分" },
		hour: {
			text: "時",
			minute: {
				"*": {
					prefix: "に",
					suffix: "分"
				},
				any: { text: "毎" }
			}
		},
		day: {
			prefix: "毎",
			text: "日"
		},
		week: { text: "週" },
		month: {
			prefix: "毎",
			text: "月"
		},
		year: {
			prefix: "毎",
			text: "年"
		},
		"q-second": { text: "秒" },
		"q-minute": {
			text: "分",
			second: { "*": { prefix: "と" } }
		},
		"q-hour": {
			text: "時",
			minute: { "*": { prefix: "と" } },
			second: { "*": { prefix: "と" } }
		}
	},
	ko: {
		"*": {
			prefix: "매",
			suffix: "",
			text: "알 수 없음",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "{{step.value}}마다" }
			},
			month: {
				"*": { prefix: "에" },
				any: {
					prefix: "의",
					text: "매월"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "의" },
				any: {
					prefix: "에",
					text: "매일"
				},
				step: {
					prefix: "",
					text: "{{step.value}}일마다"
				},
				noSpecific: {
					prefix: "에",
					text: "특정한 날 없음"
				}
			},
			dayOfWeek: {
				"*": { prefix: "의" },
				any: {
					prefix: "에",
					text: "매주"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "과",
					text: "특정한 요일 없음"
				}
			},
			hour: {
				"*": { prefix: "의" },
				any: {
					prefix: "에",
					text: "매시"
				},
				step: {
					prefix: "",
					text: "{{step.value}}시간마다"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "매분" },
				step: {
					prefix: "",
					text: "{{step.value}}분마다"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "매초" },
				step: {
					prefix: "",
					text: "{{step.value}}초마다"
				}
			}
		},
		minute: { text: "분" },
		hour: {
			text: "시",
			minute: {
				"*": {
					prefix: "에",
					suffix: "분"
				},
				any: { text: "매" }
			}
		},
		day: {
			prefix: "매",
			text: "일"
		},
		week: { text: "주" },
		month: {
			prefix: "매",
			text: "월"
		},
		year: {
			prefix: "매",
			text: "년"
		},
		"q-second": { text: "초" },
		"q-minute": {
			text: "분",
			second: { "*": { prefix: "와" } }
		},
		"q-hour": {
			text: "시",
			minute: { "*": { prefix: "와" } },
			second: { "*": { prefix: "와" } }
		}
	},
	it: {
		"*": {
			prefix: "Tutti",
			suffix: "",
			text: "Sconosciuto",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "ogni {{step.value}}" }
			},
			month: {
				"*": { prefix: "in" },
				any: {
					prefix: "in",
					text: "ogni mese"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "il" },
				any: {
					prefix: "il",
					text: "ogni giorno"
				},
				step: {
					prefix: "",
					text: "ogni {{step.value}} giorni"
				},
				noSpecific: {
					prefix: "il",
					text: "nessun giorno specifico"
				}
			},
			dayOfWeek: {
				"*": { prefix: "il" },
				any: {
					prefix: "il",
					text: "ogni giorno della settimana"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "e",
					text: "nessun giorno della settimana specifico"
				}
			},
			hour: {
				"*": { prefix: "alle" },
				any: {
					prefix: "alle",
					text: "ogni ora"
				},
				step: {
					prefix: "",
					text: "ogni {{step.value}} ore"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "ogni minuto" },
				step: {
					prefix: "",
					text: "ogni {{step.value}} minuti"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "ogni secondo" },
				step: {
					prefix: "",
					text: "ogni {{step.value}} secondi"
				}
			}
		},
		minute: { text: "Minuto" },
		hour: {
			text: "Ora",
			minute: {
				"*": {
					prefix: "al",
					suffix: "minuto/i"
				},
				any: { text: "tutti" }
			}
		},
		day: {
			prefix: "Tutti",
			text: "Giorno"
		},
		week: { text: "Settimana" },
		month: {
			prefix: "Tutti",
			text: "Mese"
		},
		year: {
			prefix: "Tutti",
			text: "Anno"
		},
		"q-second": { text: "Secondo" },
		"q-minute": {
			text: "Minuto",
			second: { "*": { prefix: "e" } }
		},
		"q-hour": {
			text: "Ora",
			minute: { "*": { prefix: "e" } },
			second: { "*": { prefix: "e" } }
		}
	},
	uk: {
		"*": {
			prefix: "Кожний",
			suffix: "",
			text: "Невідомо",
			"*": {
				value: { text: "{{value.text}}" },
				range: { text: "{{start.text}}-{{end.text}}" },
				step: { text: "кожний {{step.value}}" }
			},
			month: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "кожному місяці"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" }
			},
			day: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "кожний день"
				},
				step: {
					prefix: "",
					text: "кожні {{step.value}} дні"
				},
				noSpecific: {
					prefix: "в",
					text: "немає визначеного дня"
				}
			},
			dayOfWeek: {
				"*": { prefix: "по" },
				any: {
					prefix: "по",
					text: "кожному дню тижня"
				},
				value: { text: "{{value.alt}}" },
				range: { text: "{{start.alt}}-{{end.alt}}" },
				noSpecific: {
					prefix: "і",
					text: "немає визначеного дня"
				}
			},
			hour: {
				"*": { prefix: "в" },
				any: {
					prefix: "в",
					text: "кожну годину"
				},
				step: {
					prefix: "",
					text: "кожні {{step.value}} годин(и)"
				}
			},
			minute: {
				"*": { prefix: ":" },
				any: { text: "кожну хвилину" },
				step: {
					prefix: "",
					text: "кожні {{step.value}} хвилин(и)"
				}
			},
			second: {
				"*": { prefix: ":" },
				any: { text: "кожну секунду" },
				step: {
					prefix: "",
					text: "кожні {{step.value}} секунд(и)"
				}
			}
		},
		minute: { text: "Хвилини" },
		hour: {
			text: "Година",
			minute: {
				"*": {
					prefix: "в",
					suffix: "хвилин(а)"
				},
				any: { text: "кожні" }
			}
		},
		day: {
			prefix: "Кожний",
			text: "День"
		},
		week: { text: "Тиждень" },
		month: {
			prefix: "Кожний",
			text: "Місяц"
		},
		year: {
			prefix: "Кожний",
			text: "Рік"
		},
		"q-second": { text: "Секунда" },
		"q-minute": {
			text: "Хвилина",
			second: { "*": { prefix: "и" } }
		},
		"q-hour": {
			text: "Година",
			minute: { "*": { prefix: "і" } },
			second: { "*": { prefix: "і" } }
		}
	}
}, W = class {
	dict;
	constructor(e) {
		this.dict = e;
	}
	getTemplate(...e) {
		let t = e.map((e) => [e, "*"]);
		return m(this.dict, ...t) || "";
	}
	render(e, t, n, r, i) {
		let a = this.getTemplate(e, t, n, r);
		return V.render(a, i || {});
	}
};
function G(e, t) {
	let [n] = e.split("-"), r = U[e.toLowerCase()] || U[n.toLowerCase()] || U.en;
	return new W(p({}, U.en, r, t || {}));
}
//#endregion
//#region src/components/cron-segment.ts
function de(e) {
	let { period: t, field: i, initialCron: o = "*", l10n: s } = e, c = n(o), l = n(""), u = n([]), d = n(""), f = n(""), p = n(""), m = (e) => {
		let n = e instanceof T ? e.segments : [e];
		d.value = n.map((e) => s.render(t.value.id, i.id, e.type, a.Text, {
			field: i,
			...e.items
		})).join(","), f.value = s.getTemplate(t.value.id, i.id, e.type, a.Prefix), p.value = s.getTemplate(t.value.id, i.id, e.type, a.Suffix);
	}, h = (e) => {
		let t = E(e, i);
		t == null ? l.value = `${e} is not a valid cron segment (${i.id})` : (u.value = t.toArray(), m(t));
	}, g = (e) => {
		if (c.value == "?" && e.length == 0) return;
		let t = D(e, i);
		t == null ? l.value = `failed to convert ${e} to cron (${i.id})` : (c.value = t.toCron(), m(t));
	};
	return h(o), r(c, (e) => {
		h(e);
	}), r(u, (e) => {
		g(e);
	}), r(t, () => {
		let e = E(c.value, i);
		e != null && m(e);
	}), {
		id: i.id,
		items: i.items,
		cron: c,
		selected: u,
		error: l,
		select: (e) => {
			let t = Array.from(e).sort((e, t) => e > t ? 1 : -1);
			u.value = t;
		},
		text: d,
		prefix: f,
		suffix: p
	};
}
//#endregion
//#region src/components/cron-core.ts
function K(e) {
	return e.map((e) => e.default ?? "*").join(" ");
}
function fe(e) {
	return e !== void 0;
}
var pe = class {
	locale = "en";
	format = "crontab";
	initialValue(e) {
		return K(e);
	}
	fields(e, t) {
		let n = e == "quartz" || e == "spring", r = u(t, e), i = (e) => (t, { segmentMap: n }) => {
			if (t.cron.value == "?") return;
			let r = n.get(e);
			r && (r.cron.value = "?");
		};
		return [
			...n ? [{
				id: "second",
				items: r.secondItems
			}] : [],
			{
				id: "minute",
				items: r.minuteItems
			},
			{
				id: "hour",
				items: r.hourItems
			},
			{
				id: "day",
				items: r.dayItems,
				onChange: n ? i("dayOfWeek") : void 0,
				segmentFactories: n ? [
					y.fromString,
					v.fromString,
					C.fromString,
					b.fromString,
					w.fromString
				] : void 0
			},
			{
				id: "month",
				items: r.monthItems
			},
			{
				id: "dayOfWeek",
				default: e === "quartz" ? "?" : void 0,
				items: r.dayOfWeekItems,
				onChange: n ? i("day") : void 0,
				segmentFactories: n ? [
					y.fromString,
					v.fromString,
					C.fromString,
					b.fromString,
					w.fromString
				] : void 0
			}
		];
	}
	periods(e) {
		let t = e == "quartz" || e == "spring", n = t ? [{
			id: "q-second",
			value: []
		}] : [], r = t ? ["second"] : [], i = t ? "q-" : "";
		return [
			...n,
			{
				id: i + "minute",
				value: [...r]
			},
			{
				id: i + "hour",
				value: ["minute", ...r]
			},
			{
				id: "day",
				value: [
					"hour",
					"minute",
					...r
				]
			},
			{
				id: "week",
				value: [
					"dayOfWeek",
					"hour",
					"minute",
					...r
				]
			},
			{
				id: "month",
				value: [
					"day",
					"dayOfWeek",
					"hour",
					"minute",
					...r
				]
			},
			{
				id: "year",
				value: [
					"month",
					"day",
					"dayOfWeek",
					"hour",
					"minute",
					...r
				]
			}
		];
	}
};
function me(e, t, n) {
	let r = t.split(" ");
	if (r.length !== n.length) return;
	let i = n.filter((e, t) => !["*", "?"].includes(r[t])).map((e) => e.id);
	return e.find((e) => {
		let t = new Set(e.value);
		return i.every((e) => t.has(e));
	});
}
function q(t) {
	let i = new pe(), s = t.locale ?? i.locale, c = t.format ?? i.format, { customLocale: l, fields: u = i.fields(c, s) } = t, d = t.initialValue ?? i.initialValue(u), f = G(s, l), p = (t.periods ?? i.periods(c)).map((e) => ({
		...e,
		text: e.text ?? f.getTemplate(e.id, a.Text)
	})), m = (t.initialPeriod ? p.find((e) => e.id == t.initialPeriod) : void 0) ?? me([...p].reverse(), d, u) ?? p[p.length - 1], h = n(d), g = n(""), _ = n(m), v = n(""), y = n(""), b = u.map((e) => de({
		field: new o(e, { format: c }),
		l10n: f,
		period: _
	})), x = new Map(b.map((e) => [e.id, e])), S = e(() => _.value.value.map((e) => {
		let t = x.get(e);
		if (fe(t)) return t;
		throw Error("${fieldId} not found");
	})), C = (e) => {
		if (!e) {
			h.value = K(u);
			return;
		}
		let t = e.split(" ");
		if (t.length !== u.length) {
			g.value = "invalid pattern";
			return;
		}
		for (let e = 0; e < t.length; e++) b[e].cron.value != t[e] && (b[e].cron.value = t[e]);
		g.value = "";
	};
	C(d);
	let w = () => {
		h.value = b.map((e) => _.value.value.includes(e.id) || e.cron.value == "?" ? e.cron.value : "*").join(" ");
	}, T = () => {
		v.value = f.getTemplate(_.value.id, a.Prefix), y.value = f.getTemplate(_.value.id, a.Suffix);
	};
	return T(), r(h, C), r(_, () => {
		w(), T();
	}), b.forEach((e, t) => {
		r(e.cron, () => {
			u[t].onChange?.(e, { segmentMap: x }), w();
		}), r(e.error, (e) => {
			g.value = e;
		});
	}), {
		cron: h,
		error: g,
		segments: b,
		selected: S,
		period: {
			select: (e) => {
				let t = p.map((e) => e.id).indexOf(e);
				t != -1 && (_.value = p[t]);
			},
			selected: _,
			items: p,
			prefix: v,
			suffix: y
		}
	};
}
function J(e, { emit: t }) {
	let n = q({
		...e,
		initialValue: e.modelValue,
		initialPeriod: e.period
	});
	return r(() => e.modelValue, (e) => {
		e && (n.cron.value = e);
	}), r(() => e.period, (e) => {
		e && n.period.select(e);
	}), r(n.cron, (e) => {
		t("update:model-value", e);
	}, { immediate: e.modelValue === void 0 }), r(n.period.selected, (e) => {
		t("update:period", e.id);
	}), r(n.error, (e) => {
		t("error", e);
	}), n;
}
var Y = () => ({
	modelValue: { type: String },
	period: { type: String },
	format: { type: String },
	locale: { type: String },
	fields: { type: Array },
	periods: { type: Array },
	customLocale: { type: Object },
	cols: {
		type: Object,
		default: () => ({
			second: 5,
			minute: 5,
			hour: 4,
			day: 4
		})
	},
	disabled: {
		type: Boolean,
		default: !1
	},
	clearable: {
		type: Boolean,
		default: !0
	}
}), X = t({
	name: "VueCronCore",
	props: Y(),
	emits: [
		"update:model-value",
		"update:period",
		"error"
	],
	setup(e, t) {
		let { error: n, selected: r, period: i } = J(e, t);
		return () => {
			let e = {
				error: n,
				fields: r.value.map((e) => ({
					id: e.id,
					items: e.items,
					cron: e.cron.value,
					selectedStr: e.text.value,
					events: { "update:model-value": e.select },
					attrs: { modelValue: e.selected.value },
					prefix: e.prefix.value,
					suffix: e.suffix.value
				})),
				period: {
					attrs: { modelValue: i.selected.value.id },
					events: { "update:model-value": i.select },
					items: i.items,
					prefix: i.prefix.value,
					suffix: i.suffix.value
				}
			};
			return t.slots.default?.(e);
		};
	}
});
//#endregion
//#region src/components/select.ts
function he(e) {
	let { items: t } = e, r = /* @__PURE__ */ new Set(), i = n(0), a = () => {
		i.value += 1;
	}, o = (e) => {
		t.indexOf(e) != -1 && (r.add(e), a());
	}, s = (e) => r.has(e), c = (e) => {
		r.delete(e) && a();
	};
	return {
		values: r,
		add: o,
		toggle: (e) => {
			s(e) ? c(e) : o(e);
		},
		remove: c,
		clear: () => {
			r.clear(), a();
		},
		updated: i,
		equals: (e) => {
			if (e.length != r.size) return !1;
			for (let t of e) if (!r.has(t)) return !1;
			return !0;
		}
	};
}
function Z() {
	return {
		modelValue: { type: [
			String,
			Number,
			Array
		] },
		selection: { type: String },
		clearable: {
			type: Boolean,
			default: !1
		},
		items: {
			type: Array,
			default: () => []
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		cols: {
			type: Number,
			default: 1
		},
		itemText: {
			type: [String, Function],
			default: "text"
		},
		itemValue: {
			type: [String, Function],
			default: "value"
		},
		disabled: {
			type: Boolean,
			default: !1
		}
	};
}
function Q(t) {
	let { items: i, cols: a = 1, multiple: o = !1, itemText: s = "text", itemValue: c = "value" } = t, l = he(t), u = n(o ? [] : null), d = n(""), f = (e) => {
		o ? l.toggle(e) : (l.clear(), l.add(e));
	}, p = (e) => {
		if (e === null) return !1;
		let t = m(e);
		return Array.isArray(u.value) ? u.value.includes(t) : u.value === t;
	}, m = (e) => typeof c == "function" ? c(e) : e[c], h = (e) => typeof s == "function" ? s(e) : e[s], g = new Map(i.map((e) => [m(e), e])), v = (e) => {
		l.equals(e) || (l.clear(), e.forEach((e) => f(e)));
	}, y = (e) => {
		e = Array.isArray(e) ? e : [e];
		let t = e.map((e) => g.get(e)).filter((e) => !!e);
		v(t);
	};
	r(l.updated, () => {
		let e = Array.from(l.values);
		u.value = o ? e.map(m) : m(e[0]), d.value = e.map(h).join(",");
	});
	let b = e(() => o ? !Array.isArray(u.value) || u.value.length == 0 : !!u.value);
	return {
		...l,
		select: f,
		selected: u,
		selectedStr: d,
		itemRows: _(i, a),
		setItems: v,
		setValues: y,
		isEmpty: b,
		has: p
	};
}
function ge(e, t, { emit: n }) {
	let i = Q(e);
	return r(i.selected, () => {
		n("update:model-value", i.selected.value);
	}), r(t, (e) => {
		e && i.setValues(e);
	}, { immediate: !0 }), i;
}
var _e = t({
	name: "RenderlessSelect",
	props: {
		...Z(),
		modelValue: { type: [
			String,
			Number,
			Array
		] },
		selection: { type: String },
		clearable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t, slots: n }) {
		let i = Q(e);
		return r(i.selected, () => {
			t("update:modelValue", i.selected.value);
		}), r(() => e.modelValue, (e) => {
			e && i.setValues(e);
		}, { immediate: !0 }), () => {
			let t = {
				selectedStr: e.selection || i.selectedStr.value,
				modelValue: e.modelValue,
				items: e.items,
				select: i.select,
				isSelected: i.has,
				clearable: e.clearable && !i.isEmpty.value,
				clear: i.clear,
				cols: e.cols,
				rows: i.itemRows.length,
				itemRows: i.itemRows,
				multiple: e.multiple,
				itemText: e.itemText,
				itemValue: e.itemValue
			};
			return n.default?.(t);
		};
	}
}), $ = { install: (e) => {
	e.component("CronCore", X);
} };
//#endregion
export { X as CronCore, $ as CronCorePlugin, $ as default, i as FieldPattern, o as FieldWrapper, W as L10nEngine, _e as RenderlessSelect, a as TextPosition, G as createL10n, Y as cronCoreProps, u as defaultItems, l as genItems, d as pad, Z as selectProps, J as setupCron, ge as setupSelect, _ as splitArray, q as useCron, Q as useSelect };

//# sourceMappingURL=core.js.map